<template>
  <div :class="$style.root">
    <LayoutCollectionTypeHeadingComponent
      :pageData="pageData"
      :parentPageData="parentPageData"
      routeName="fellows-slug"
      parentRouteName="fellows"
    />

    <CoreBlocksComponent
      v-if="blocks?.length"
      :blocks="blocks"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  parentPageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const blocks = computed(() => {
  return localizedData?.value?.blocks
})
</script>

<style module>
.root {}
</style>
